import React from "react";
import { BrowserRouter, Routes, Route, Link } from "react-router-dom";
import "./App.css";

import Home from "./pages/Home";
import Weather from "./apps/weather/Weather";
import JobAssistant from "./apps/jobassistant/JobAssistant";
import NasaPod from "./apps/nasapod/NasaPod";

function App() {
  return (
    <BrowserRouter>
      <div className="App">
        <header className="site-header">
          <Link to="/" className="logo logo-btn" style={{ fontSize: '2rem', fontWeight: 700 }}>
            Arecah
          </Link>
          <a href="mailto:info@arecah.com" className="header-cta">
            Get in touch
          </a>
        </header>

        <main>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/weather" element={<Weather />} />
            <Route path="/jobassistant" element={<JobAssistant />} />
            <Route path="/nasapod" element={<NasaPod />} />
          </Routes>
        </main>

        <footer className="site-footer">
          <span>© Arecah</span>
          <a href="mailto:info@arecah.com">info@arecah.com</a>
        </footer>
      </div>
    </BrowserRouter>
  );
}

export default App;
